import React, { useState } from "react";

import { Tooltip } from "react-tooltip";
import {
  COLORS,
  FONT_SIZE,
  FONT_WEIGHT,
  FONTS,
} from "../../../constants/Styles";
import { v4 as uuidv4 } from "uuid";
import { Container } from "./ToolTipStyles";

function FlashPCBTooltip({
  children,
  content,
}: {
  children: React.ReactNode;
  content?: string | React.ReactNode;
}) {
  const [tooltipId] = useState(uuidv4());
  return (
    <>
      <Container data-tooltip-id={tooltipId}>{children}</Container>
      {content && (
        <Tooltip
          id={tooltipId}
          style={{
            background: COLORS.secondaryLight,
            color: COLORS.inputGray,
            maxWidth: "20rem",
            maxHeight: "90vh",
            whiteSpace: "normal",
            zIndex: 2,
            fontSize: FONT_SIZE.size14,
            fontWeight: FONT_WEIGHT.weight500,
            fontFamily: FONTS.body,
          }}
          data-tooltip-delay-show={0}
          delayShow={0}
          delayHide={0}
          data-tooltip-delay-hide={0}
          opacity={1}
          clickable
        >
          {content}
        </Tooltip>
      )}
    </>
  );
}

export default FlashPCBTooltip;
